import { render, staticRenderFns } from "./ProductOfTheDay.vue?vue&type=template&id=1c1d9480&scoped=true"
import script from "./ProductOfTheDay.vue?vue&type=script&lang=js"
export * from "./ProductOfTheDay.vue?vue&type=script&lang=js"
import style0 from "./ProductOfTheDay.vue?vue&type=style&index=0&id=1c1d9480&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1d9480",
  null
  
)

export default component.exports